import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'monthName',
  standalone: true,
})
export class MonthNamePipe implements PipeTransform {
  monthNamesEng = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  monthNamesGer = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
  transform(date: Date | string, lang: string = 'en'): string {
    let _date: Date

    if (typeof date === 'string') {
      _date = new Date(date)
    } else {
      _date = date
    }

    if (date) {
      const monthInteger = _date.getMonth()
      return lang === 'de-DE' ? this.monthNamesGer[monthInteger] : this.monthNamesEng[monthInteger]
    } else {
      return ''
    }
  }
}
